module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008part1"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter1"
    }
  }, [_vm._v("About This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter2"
    }
  }, [_vm._v("Finding Inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter3"
    }
  }, [_vm._v("Sourcing Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter4"
    }
  }, [_vm._v("Elements of a Handmade Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter5"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter6"
    }
  }, [_vm._v("Crafting Tips")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015part2"
    }
  }, [_c('strong', [_vm._v("RETRO HOMESPUN")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter7"
    }
  }, [_vm._v("1. Retro Homespun Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Cupcake Liner Pom-Poms")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Yarn-Wrapped Bottles")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Embroidery Welcome Hoop")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Mix-&-Match Pocket Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Felt Bud Boutonniers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Felt-Flower Ring Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Vintage-Plate Table Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Fabric-Wrapped Favors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/025part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("GIRLY ROMANTIC")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Vintage Key Save-the-Date")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Embossed & Edged Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Dyed Coffee-Filter Pom-Poms")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/029chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Fabric-Flower Veil")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Ruffle Roll Purse")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Teacup Centerpieces")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Scalloped Cupcake Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Picture-Frame Charm Necklaces")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/034chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Paper-Wrapped Favors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("HAPPY GRAPHIC")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/036chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Sparkle & Spin Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Paper-Link Chains")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/038chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Heart-Shaped Programs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/039chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Decal Table Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/040chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Silk-Screened Place Mats")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/041chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Bride & Groom Cake Topper")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/042chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Kraft Welcome Bags")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/043chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Button Seating Cards & Favors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/044part5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ORGANIC MINIMAL")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/045chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Balsa Wood Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/046chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Tallow-Berry-&-Cotton-Bud Boutonniers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/047chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Patterned-Paper Programs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/048chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Rubber-Stamped Confetti Bags")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/049chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Chalkboard-Paint Table Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/050chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Kraft Paper Menus")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/051chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Terrarium Place Cards & Favors")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/052chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Stenciled Table Runner")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/053chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Test-Tube Favors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/054part6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("MODERN CLASSIC")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/055chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Calligraphy")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/056chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Modern Classic Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/057chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Silhouette Bride & Groom Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/058chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Rosette Boutonnieres")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/059chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Layered Coakade Ring Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/060chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Ribon Drink Flags")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/061chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Bou-Tie Napkins")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/062chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Puched-Paper Flower Centerpiece")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/063chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Crepe Paper-Flower Cake Topper")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/064chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Crepe Paper-Cracker Favors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065part7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("FOUND")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/066chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Found-Paper Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/067chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Découpage Votives & Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/068chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fabric Pennants")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/069chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Paper-Flower Wreath")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/070chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Fabric-Scrap Hair Clips")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/071chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Dress–Pattern–&–Found–Tissue Bouquet")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/072chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Peg-Board Seating Chart")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/073chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Clipboard Menus")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/074chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Bride & Groom Shakeys")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "part8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/075part8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("APPENDIXES")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/076chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/077chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/078chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Planning Time line")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "chapter64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/079chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Address and Assemble Your Invitations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/080index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/005copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5acceaa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007toc.vue
// module id = 69
// module chunks = 0